import { FormGroup, FormHelperText, FormLabel, Tooltip } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { Help } from "@material-ui/icons";
import Autocomplete from "@material-ui/lab/Autocomplete";
import clsx from "clsx";
import { Controller } from "react-hook-form";
import { connect } from "react-redux";
import { clearDataSetByNameAction } from "redux/actions/datasetsAction";

function FormSelectV2({
  control,
  name,
  selectOptions,
  initialLabel,
  getValues,
  setValue,
  required,
  requiredMessage,
  loadChildrenDataSet,
  childrenDataSet,
  childrenSelect,
  grandchildrenSelect,
  childrenList,
  classes,
  disabled,
  onOptionChange,
  trigger,
  handleSetFilter,
  filterListKey,
  label,
  tooltipLabel,
  rules,
  ...props
}) {
  const theme = useTheme();

  const fieldVal = (name) => {
    const value = getValues(name);
    return value ? value : null;
  };

  return (
    <FormGroup>
      <FormLabel>
        {label}
        {tooltipLabel && (
          <Tooltip title={tooltipLabel}>
            <Help className={classes.tooltipInfoIcon} />
          </Tooltip>
        )}
      </FormLabel>

      <Controller
        render={({ field: { onChange, name }, fieldState: { error } }) => (
          <>
            <Autocomplete
              noOptionsText={"Sem opções"}
              name={name}
              options={selectOptions ? selectOptions : []}
              value={fieldVal(name)}
              getOptionLabel={(option) => {
                if (typeof option === "string") return option;
                return option?.label ?? option?.value ?? option?.keyValue ?? "";
              }}
              getOptionSelected={(option, value) => option?.code === value?.code}
              disabled={disabled !== undefined ? disabled : false}
              data-testid={"form-select-" + name}
              classes={{
                inputRoot: clsx({
                  [classes.selectBorderWarningInputRoot]: !!error,
                }),
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={!initialLabel ? "Seleccione opção" : initialLabel}
                  variant="outlined"
                  InputLabelProps={{
                    style: {
                      fontWeight: "normal",
                      fontSize: "14px",
                      color: theme.palette.gray[600],
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "block",
                      width: "calc(100% - 24px)",
                      maxWidth: "calc(100% - 24px)",
                    },
                  }}
                />
              )}
              onChange={(_, data) => {
                onChange(data);
                if (loadChildrenDataSet !== undefined) {
                  if (data != null) loadChildrenDataSet(childrenDataSet, data.keyValue ?? data.code, true);
                  else props.clearDataSetByName(childrenDataSet);
                }
                if (onOptionChange !== undefined) {
                  onOptionChange(data);
                }
                if (childrenDataSet !== undefined) {
                  setValue(childrenSelect, null);
                  if (trigger !== undefined) trigger(childrenSelect);
                }
                if (handleSetFilter) {
                  handleSetFilter(filterListKey, data ? data.code : null, [childrenSelect, grandchildrenSelect]);
                }

                if (childrenList?.length > 0 && loadChildrenDataSet !== undefined) {
                  childrenList?.forEach((child) => {
                    if (data != null) loadChildrenDataSet(child.dataset, data.keyValue ?? data.code, true);
                    else props.clearDataSetByName(child.dataset);

                    if (child.dataset !== undefined) {
                      setValue(child.name, null);
                      if (trigger !== undefined) trigger(child.name);
                    }
                    if (handleSetFilter) {
                      handleSetFilter(filterListKey, data ? data.code : null, [child.name]);
                    }
                  });
                }
              }}
            />
            {error && (
              <FormHelperText color={theme.palette.warning.main + "!important"}>{error?.message}</FormHelperText>
            )}
          </>
        )}
        name={name}
        rules={{
          required: {
            value: required,
            message: requiredMessage,
          },
          ...rules,
        }}
        control={control}
      />
    </FormGroup>
  );
}

const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = (dispatch) => ({
  clearDataSetByName: (name) => dispatch(clearDataSetByNameAction(name)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormSelectV2);
